// 微信支付宝转账
const wxRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `transferAccounts/wx/index${i + 1}`,
  name: `transferAccounts/wx/Index${i + 1}`,
  component: () => import(`@/views/shopping/transferAccounts/wx/index${i + 1}.vue`)
}))
const branch1wxRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `transferAccounts/wx/branch1/index${i + 1}`,
  name: `transferAccounts/wx/branch1/Index${i + 1}`,
  component: () => import(`@/views/shopping/transferAccounts/wx/branch1/index${i + 1}.vue`)
}))
const branch2wxRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `transferAccounts/wx/branch2/index${i + 1}`,
  name: `transferAccounts/wx/branch2/Index${i + 1}`,
  component: () => import(`@/views/shopping/transferAccounts/wx/branch2/index${i + 1}.vue`)
}))
const branch3wxRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `transferAccounts/wx/branch3/index${i + 1}`,
  name: `transferAccounts/wx/branch3/Index${i + 1}`,
  component: () => import(`@/views/shopping/transferAccounts/wx/branch3/index${i + 1}.vue`)
}))
const zfbRoutes = Array.from({ length:9 }, (_, i) => ({
  path: `transferAccounts/zfb/index${i + 1}`,
  name: `transferAccounts/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/transferAccounts/zfb/index${i + 1}.vue`)
}))
const branchzfbRoutes = Array.from({ length:7 }, (_, i) => ({
  path: `transferAccounts/zfb/branch/index${i + 1}`,
  name: `transferAccounts/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/transferAccounts/zfb/branch/index${i + 1}.vue`)
}))

import transferAccountsIndex from '@/views/shopping/transferAccounts/index'



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'transferAccounts/index',
        name: 'transferAccountsIndex',
        component: transferAccountsIndex
      },
    // 微信支付宝转账，开始
    ...wxRoutes,
    ...branch1wxRoutes,
    ...branch2wxRoutes,
    ...branch3wxRoutes,
    ...zfbRoutes,
    ...branchzfbRoutes,

  ],
};
